import { Directive, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';

import { Subject, SubscriptionLike, timer } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@Directive({
  selector: 'countdown',
})
export class CountdownDirective implements OnChanges, OnDestroy {
  private counter$ = new Subject<any>();
  private countSub$: SubscriptionLike;

  @Input() counter: number;
  @Input() interval: number;
  @Output() value = new EventEmitter<number>();

  constructor() {
    this.countSub$ = this.counter$
      .pipe(
        switchMap((options: any) =>
          timer(0, options.interval).pipe(
            take(options.count),
            tap(() => this.value.emit(--options.count))
          )
        )
      )
      .subscribe();
  }

  ngOnChanges() {
    this.counter$.next({ count: this.counter, interval: this.interval });
  }

  ngOnDestroy() {
    if (this.countSub$) {
      this.countSub$.unsubscribe();
    }
  }
}
